<template>
  <div class="card profile-card" :class="{ 'public-profile-card': public }">
    <div class="card-body">
      <div class="candidate-resume-detail">
        <div class="profile-header">
          <div class="profile-info">
            <div class="position-relative">
              <img
                v-if="application.candidate.avatar"
                width="200"
                height="200"
                :src="application.candidate.avatar"
                alt=""
                class="profil-img"
              >
              <img
                v-else
                width="200"
                height="200"
                src="@/images/anonymous-profile.jpg"
                alt=""
                class="profil-img"
              >
            </div>
            <div class="content">
              <h3 class="candidate-name">
                {{ application.user.firstName }} {{ application.user.lastName }}
              </h3>
              <div class="candidate-metas">
                <span v-if="application.candidate.age" class="candidate-age">{{ application.candidate.age }} ans</span>
                <span v-if="application.candidate.address?.cityName" class="candidate-city"> | {{ application.candidate.address.cityName }}</span>
              </div>
              <div class="experience">
                {{ $t('views.resume_shop.candidate_resume_detail.experience') }} : {{ application.experience?.name }}
              </div>
              <div
                v-for="degree in application.candidate.degrees"
                :key="degree.id"
                class="degrees"
              >
                {{ degree.name }}
              </div>
            </div>
          </div>
          <div class="profil-actions">
            <a :href="`mailto:${application.user.email}` " class="btn btn-rounded btn-light-purple">
              <v-sprite color="currentColor" icon="bulle" />
              <span>{{ application.user.email }}</span>
            </a>
            <a
              v-if="application.candidate.phoneNumber"
              :href="`tel:${application.candidate.phoneNumber}`"
              class="btn btn-rounded btn-outline-primary">
              <v-sprite color="currentColor" icon="call" />
              {{ application.candidate.phoneNumber }}
            </a>
          </div>
        </div>

        <div class="profile-secondary">
          <div v-if="application.candidate.languages?.length > 0" class="item">
            <p class="title">{{ $t('views.resume.languages') }}</p>
            <ul class="list-icon list-unstyled">
              <li v-for="lang in application.candidate.languages" :key="lang.id">
                {{ lang.name }}
                <v-sprite color="var(--bs-primary)" icon="check" />
              </li>
            </ul>
          </div>
          <div v-if="application.candidate.licences?.length > 0" class="item">
            <p class="title">{{ $t('views.resume.licences') }}</p>
            <ul class="list-icon list-unstyled">
              <li v-for="licence in application.candidate.licences" :key="licence.id">
                {{ $t('views.resume.licences') }} {{ licence.name }}
                <v-sprite color="var(--bs-primary)" icon="check" />
              </li>
            </ul>
          </div>
          <div v-if="application.candidate.locomotions?.length > 0" class="item">
            <p class="title">{{ $t('views.resume.locomotion') }}</p>
            <ul class="list-icon list-unstyled">
              <li v-for="locomotion in application.candidate.locomotions" :key="locomotion.id" class="locomotion">
                {{ locomotion.name }}
                <v-sprite color="var(--bs-primary)" icon="check" />
              </li>
            </ul>
          </div>
        </div>

        <div v-if="application.candidate.previousJobs?.length > 0" class="profile-tertiary profile-block">
          <h4 class="title">
            <v-sprite color="currentColor" icon="cv" />
            {{ $t('views.resume_shop.candidate_resume_detail.experiences') }}
          </h4>

          <div v-for="(previousJob, index) in application.candidate.previousJobs" :key="index" class="experience">
            <p class="experience-info">
              {{ dateFormatted(previousJob.beginningDate) }} -
              {{ previousJob.stillInOffice ? $t('views.resume_shop.candidate_resume_detail.candidate_still_in_office') : dateFormatted(previousJob.endDate) }}<br>
              <span class="fw-bold">{{ previousJob.job.name }}</span>
            </p>
            <div class="experience-description">
              {{ previousJob.description }}
            </div>
          </div>
        </div>

        <div class="profile-skills profile-block">
          <h4 class="title">Son profil</h4>
          <div v-if="application.candidate.skills?.length" class="candidate-skill">
            <ul class="list-icon list-unstyled">
              <li v-for="skill in application.candidate.skills" :key="skill.id">
                {{ skill.name }}
                <v-sprite color="var(--bs-primary)" icon="check" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import Application from '../interfaces/application';

export default defineComponent({
  name: 'ProfileCard',
  props: {
    application: {
      type: Object as PropType<Application>,
      required: true,
    },
    public: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    dateFormatted(date: string): string {
      if (!date) return '';
      const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long' };
      return new Date(date).toLocaleDateString('fr-FR', options);
    },
  },
});
</script>

<style scoped lang="scss">
@import '../../scss/config/config';
@import 'sass-mq/mq';

.profile-card {
  background-color: $white;
  color: $gray-900;

  @media print {
    box-shadow: none;

    .card-body {
      padding: 0;
    }
  }
}

.profil-img {
  border-radius: 50%;
  object-fit: cover;
}

.card-body {
  padding: 0;
}

.profile-secondary {
  display: grid;
  gap: 32px;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 32px;
}

.profile-header {
  flex-direction: row;
}
</style>
